module.exports = __webpack_public_path__ + "static/media/md-build.b360dc24.svg";